import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '@barthauer/abc/core/authentication';
import { DataService as CoreDataService, QueryColumnSortOrder } from '@barthauer/abc/core/data';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { AbcToastComponent, _AbcScrollViewComponent, _AbcTreeComponent } from '@barthauer/abc/ui-components';
import * as events from 'devextreme/events';
import { loadMessages } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import enMessages from 'devextreme/localization/messages/en.json';
import { forkJoin, Subscription } from 'rxjs';
import dtDe from '../../assets/resources/dt.de.json';
import dtEn from '../../assets/resources/dt.en.json';
import { FavoriteListComponent } from '../core/favorite-list/favorite-list.component';
import { Position, StorageEnum, ToastAnimationShowType, ToastType } from '../models/enumeration-list.model';
import { IToastAnimation, PositionIValue } from '../models/interfaces.models';
import { NavigationMenu } from '../models/organizational-structure.model';
import { AppService } from '../services/app.service';
import { DataService, ObjectKeys } from '../services/data.service';
import { LanguageService } from '../services/language.service';
import { ScreenService } from '../services/screen.service';
export enum NavigationSvg {
  DASHBOARD = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M57,20H20V63H57ZM51,57H26V26H51Z"/><path class="cls-1" d="M63,20V51h37V20ZM94,45H69V26H94Z"/><path class="cls-1" d="M20,69v31H57V69ZM51,94H26V75H51Z"/><path class="cls-1" d="M63,57v43h37V57ZM94,94H69V63H94Z"/></svg>',
  MODULE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M101,56.24V30.84L79,18.14l-19,11-19-11L19,30.84v25.4l19,11V89.14l22,12.72L82,89.14V67.23ZM38,60.31,25,52.78v-15l13,7.5Zm-10-27.75,13-7.49,13,7.51-13,7.5Zm29,5.22v15l-13,7.5v-15Zm0,55.43L44,85.68v-15l13,7.51Zm-10-27.74L60,58l13,7.48L60,73ZM63,37.78l13,7.49v15l-13-7.5Zm0,55.43v-15l13-7.51v15Zm3-60.63,13-7.51,13,7.49L79,40.08ZM82,45.27l13-7.5v15L82,60.31Z"/></svg>',
  LIBRARY = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M96.29,64.36a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41c0-3.05,1.29-4.32,1.85-4.72h0a3,3,0,0,0,1.37-2.86,2.73,2.73,0,0,0-1.82-2.29c-.29-.22-1.4-1.29-1.4-4.43s1.29-4.32,1.85-4.72h0a3,3,0,0,0-.64-5.22L62.47,17.22a3,3,0,0,0-2.87.35L26.65,41.34h0c-1.3.94-4.34,3.76-4.34,9.58a12.5,12.5,0,0,0,2,7.25,12.52,12.52,0,0,0-2,7,12.56,12.56,0,0,0,2,7.26,12.46,12.46,0,0,0-2,7c0,7.51,4.38,9.67,4.88,9.9l.1,0,33.18,13.32a2.94,2.94,0,0,0,1.12.22,3,3,0,0,0,1.76-.57l33-23.77a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41C94.44,66,95.73,64.76,96.29,64.36Zm-67.11-17L56.76,58.39a13,13,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,55.37c-.27-.21-1.42-1.26-1.42-4.45A6.74,6.74,0,0,1,29.18,47.31Zm.32,8,.14.06-.12-.05Zm-.33,6.34L56.76,72.69a13.06,13.06,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,69.67c-.27-.21-1.42-1.26-1.42-4.45A6.81,6.81,0,0,1,29.17,61.62Zm.35,8h0l.12,0ZM90,61.48,62,81.69a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,55.71A12.59,12.59,0,0,0,90,61.48Zm0-14.3L62,67.39a8.09,8.09,0,0,1-.52-3.14c0-3.06,1.29-4.32,1.85-4.72L88.46,41.4A12.6,12.6,0,0,0,90,47.18ZM61.77,23.4,88.36,34.08,61.17,53.7,34.57,43ZM28.3,79.52a6.81,6.81,0,0,1,.87-3.6L56.76,87a13.06,13.06,0,0,0-1.27,5.86c0,.53,0,1,.06,1.5L29.61,83.93C29.51,83.85,28.3,82.76,28.3,79.52ZM62,96a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,70A12.55,12.55,0,0,0,90,75.78Z"/></svg>',
  DOCUMENTS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:white;}</style></defs><path class="cls-1" d="M96.29,64.36a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41c0-3.05,1.29-4.32,1.85-4.72h0a3,3,0,0,0,1.37-2.86,2.73,2.73,0,0,0-1.82-2.29c-.29-.22-1.4-1.29-1.4-4.43s1.29-4.32,1.85-4.72h0a3,3,0,0,0-.64-5.22L62.47,17.22a3,3,0,0,0-2.87.35L26.65,41.34h0c-1.3.94-4.34,3.76-4.34,9.58a12.5,12.5,0,0,0,2,7.25,12.52,12.52,0,0,0-2,7,12.56,12.56,0,0,0,2,7.26,12.46,12.46,0,0,0-2,7c0,7.51,4.38,9.67,4.88,9.9l.1,0,33.18,13.32a2.94,2.94,0,0,0,1.12.22,3,3,0,0,0,1.76-.57l33-23.77a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41C94.44,66,95.73,64.76,96.29,64.36Zm-67.11-17L56.76,58.39a13,13,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,55.37c-.27-.21-1.42-1.26-1.42-4.45A6.74,6.74,0,0,1,29.18,47.31Zm.32,8,.14.06-.12-.05Zm-.33,6.34L56.76,72.69a13.06,13.06,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,69.67c-.27-.21-1.42-1.26-1.42-4.45A6.81,6.81,0,0,1,29.17,61.62Zm.35,8h0l.12,0ZM90,61.48,62,81.69a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,55.71A12.59,12.59,0,0,0,90,61.48Zm0-14.3L62,67.39a8.09,8.09,0,0,1-.52-3.14c0-3.06,1.29-4.32,1.85-4.72L88.46,41.4A12.6,12.6,0,0,0,90,47.18ZM61.77,23.4,88.36,34.08,61.17,53.7,34.57,43ZM28.3,79.52a6.81,6.81,0,0,1,.87-3.6L56.76,87a13.06,13.06,0,0,0-1.27,5.86c0,.53,0,1,.06,1.5L29.61,83.93C29.51,83.85,28.3,82.76,28.3,79.52ZM62,96a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,70A12.55,12.55,0,0,0,90,75.78Z"/></svg>',
  COMPANY = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:828294;}</style></defs><path class="cls-1" d="M83.22,41.66v-12.73l-19.65-8.93-30.36,8.93v19.47l-16,4.71v46.89H99.22V48.93l-16-7.27Zm-22.01,52.34h-22v-14l-10,1v13h-6V57.6l23.91-7.03,14.09,6.41v37.03Zm16,0h-10V53.11l-19.65-8.93-8.36,2.46v-13.22l23.91-7.03,14.1,6.41v61.21Zm16,0h-10V48.25l10,4.55v41.2Z"/><polygon class="cls-1" points="47.12 63.18 55.21 65.85 55.21 60.26 47.12 56.59 47.12 63.18"/><polygon class="cls-1" points="47.12 75.81 55.21 77.49 55.21 71.51 47.12 69.22 47.12 75.81"/><polygon class="cls-1" points="47.12 88.33 55.21 88.33 55.21 82.96 47.12 81.74 47.12 88.33"/></svg>',
  HOME = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;fill-rule:evenodd;}</style></defs><path class="cls-1" d="M98.72,71,93,65.31V96H66V75H54V96H27V65.31L21.28,71,17,66.76,60,24l43,42.77ZM33,59.34V90H48V69H72V90H87V59.34L60,32.48Z"/></svg>',
  MEASURES = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M15.76,57.84l46.4,46.4L85.27,81.13l-46.4-46.4Zm46.4,37.92L24.24,57.84,38.87,43.21l4.19,4.19-4.2,4.2,4.24,4.25,4.2-4.21,4.19,4.19L47.29,60l4.24,4.24,4.21-4.2,4.18,4.18-4.2,4.21L60,72.71l4.21-4.2,4.19,4.19-4.21,4.2,4.25,4.24,4.2-4.2,4.19,4.19Z"/><polygon class="cls-1" points="97.88 60.03 93.68 64.24 55.76 26.32 59.97 22.12 55.72 17.88 43.08 30.53 47.32 34.77 51.52 30.57 89.44 68.48 85.23 72.68 89.47 76.92 102.12 64.28 97.88 60.03"/></svg>',
  AUDIT = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M101.43,82.58c1.92-2.75,3.05-6.09,3.05-9.7,0-8.36-6.04-15.29-13.99-16.72V21.22H54.31l-24.81,24.81v55.19h61v-11.63c2.45-.44,4.72-1.4,6.69-2.77l8.4,8.4,4.24-4.24-8.4-8.4ZM53.5,30.51v14.71h-14.71l14.71-14.71Zm-18,64.71V51.22h24V27.22h25v28.93c-7.96,1.41-14.01,8.35-14.01,16.72s6.05,15.31,14.01,16.72v5.63H35.5Zm51.99-11.35c-6.07,0-11-4.93-11-11s4.93-11,11-11,11,4.93,11,11-4.93,11-11,11Z"/><path class="cls-1" d="M68.5,58.22h-26.01v6h22.61c.84-2.17,1.99-4.19,3.39-6Z"/><path class="cls-1" d="M63.49,72.87c0-.9,.05-1.78,.15-2.65h-21.14v6h21.23c-.15-1.1-.24-2.21-.24-3.35Z"/><path class="cls-1" d="M42.5,82.22v6h26.56c-1.5-1.8-2.74-3.82-3.67-6h-22.89Z"/></svg>',
  TASK = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M40,57h18v-18h-18v18Zm6-12h6v6h-6v-6Z"/><rect class="cls-1" x="64" y="39" width="16" height="6"/><rect class="cls-1" x="64" y="51" width="10" height="6"/><path class="cls-1" d="M40,81h18v-18h-18v18Zm6-12h6v6h-6v-6Z"/><rect class="cls-1" x="64" y="63" width="16" height="6"/><rect class="cls-1" x="64" y="75" width="10" height="6"/><path class="cls-1" d="M69.5,20l-1.5-6h-16l-1.5,6H28V100H92V20h-22.5Zm-12.81,0h6.63l1.5,6h-9.62l1.5-6Zm29.31,74H34V26h12v6h28v-6h12V94Z"/></svg>',
  REPORTS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fillwhite;}</style></defs><polygon class="cls-1" points="18.5 26 24.5 26 24.5 94 18.5 94 18.5 100 36.5 100 36.5 94 30.5 94 30.5 26 36.5 26 36.5 20 18.5 20 18.5 26"/><polygon class="cls-1" points="59.43 76.08 68.5 85.16 84.57 69.08 80.33 64.84 68.5 76.67 63.67 71.84 59.43 76.08"/><path class="cls-1" d="M69.74,20H42.5v80h59V51.76ZM71.5,30.24,91.26,50H71.5ZM95.5,94h-47V26h17V56h30Z"/></svg>',
  FAVORITE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fillwhite}</style></defs><path class="cls-1" d="M76.56,24c-4.16,0-11.01,1.33-16.56,8.15-5.55-6.81-12.4-8.15-16.56-8.15-17.76,0-28.7,16.93-22.25,36.77,7.34,22.56,33.72,35.23,38.81,35.23s31.46-12.67,38.81-35.23c6.46-19.83-4.49-36.77-22.25-36.77Zm16.54,34.91c-6.04,18.56-28.08,30.22-33.1,31.07-5.02-.84-27.06-12.51-33.1-31.07-2.7-8.3-1.91-16.28,2.18-21.91,3.28-4.51,8.38-7,14.36-7,3.83,0,9.34,1,15.3,10.14,.47,.72,.89,1.5,1.26,2.3,.38-.8,.79-1.58,1.26-2.3,5.96-9.14,11.47-10.14,15.3-10.14,5.98,0,11.09,2.49,14.36,7,4.09,5.63,4.88,13.61,2.18,21.91Z"/></svg>',
  ADMINISTRATION = '<svg fill="#ffffff" width="26" height="26"  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 7H8V6h11zM8 15h6.363l1.17-1H8zm-6 3V3h19v5h1V2H1v17h8.736c.038-.043.066-.09.107-.131l.087-.081.922-.788zm15.49-8H8v1h9.106a3.802 3.802 0 0 1 .385-1zM12 21h1v-1h-1zm-8-8h3v3H4zm1 2h1v-1H5zm2-7H4V5h3zM6 6H5v1h1zm18 5.886a4.072 4.072 0 0 1-1.4 2.621 2.805 2.805 0 0 1-2.496.385l-.057-.013-6.661 7.489a1.99 1.99 0 1 1-2.835-2.793c.026-.025 6.462-5.523 7.663-6.552a2.872 2.872 0 0 1 .808-3.317 3.873 3.873 0 0 1 2.843-.635.544.544 0 0 1 .487.46.603.603 0 0 1-.301.606l-1.646 1.285.309.788.63.469 1.708-1.327a.584.584 0 0 1 .652-.06.61.61 0 0 1 .296.594zm-1.396 1.08l-.824.64a.702.702 0 0 1-.853.009l-1.011-.781a.855.855 0 0 1-.09-.152l-.432-1.1a.713.713 0 0 1 .228-.817l.863-.67a2.384 2.384 0 0 0-.85.4 1.898 1.898 0 0 0-.416 2.332.67.67 0 0 1-.134.766c-.019.017-.037.035-7.856 6.716a.986.986 0 0 0 .03 1.373 1.015 1.015 0 0 0 1.4 0l6.745-7.585a.687.687 0 0 1 .787-.214l.142.035a1.856 1.856 0 0 0 1.652-.2 2.515 2.515 0 0 0 .62-.752zM7 12H4V9h3zm-1-2H5v1h1z"/><path fill="none" d="M0 0h24v24H0z"/></svg>',
  STAFF_MEMBERS = '<svg fill="#ffffff" width="26" height="26" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 297 297" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M225.656,77.674c21.414,0,38.837-17.422,38.837-38.837S247.07,0,225.656,0S186.82,17.422,186.82,38.837 S204.241,77.674,225.656,77.674z M225.656,16.819c12.14,0,22.018,9.878,22.018,22.018s-9.878,22.018-22.018,22.018 s-22.017-9.878-22.017-22.018S213.515,16.819,225.656,16.819z"></path> <path d="m270.577,194.311c-13.621,31.839-44.341,54.195-80.55,56.439l14.699-14.7c3.284-3.285 3.284-8.609 0-11.893-3.285-3.283-8.608-3.283-11.893,0l-29.243,29.244c-3.284,3.285-3.284,8.609 0,11.893l29.243,29.243c1.642,1.641 3.794,2.463 5.947,2.463 2.153,0 4.304-0.821 5.947-2.463 3.284-3.284 3.284-8.609 0-11.893l-15.027-15.026c53.241-2.636 101.018-42.65 104.726-94.915 0.819-11.542 0.215-46.283 0.215-46.283 0-16.58-10.288-31.241-26.017-36.483-0.064-0.021-10.928-3.355-10.928-3.355-4.279-1.316-8.835,0.956-10.368,5.159l-14.031,38.496c0,0-3.547-21.974-3.841-22.459 0.017-0.029 0.039-0.054 0.056-0.083l7.453-12.909c0.795-1.378 0.795-3.074 0-4.452-0.795-1.378-2.266-2.226-3.856-2.226h-14.906c-1.59,0-3.061,0.848-3.856,2.226s-0.795,3.074 0,4.452l7.453,12.909c0.017,0.029 0.038,0.055 0.056,0.083-0.294,0.485-3.841,22.459-3.841,22.459l-14.03-38.496c-1.532-4.204-6.091-6.477-10.368-5.159 0,0-10.864,3.334-10.928,3.355-15.729,5.242-26.296,19.903-26.296,36.483v59.482c0,4.644 3.765,8.409 8.409,8.409h105.775zm-97.366-16.818v-51.073c0-9.298 5.906-17.524 14.707-20.499l2.998-.92 26.421,72.491h-44.126zm104.511-9.146c0,5.272-6.892,9.146-12.459,9.146h-31.289l26.422-72.491 2.998,.92c8.802,2.975 14.328,11.2 14.328,20.499 0-1.42109e-14 0,30.74 0,41.926z"></path> <path d="m71.7,219.894c14.654,0 26.576-11.922 26.576-26.576 0-14.653-11.922-26.576-26.576-26.576-14.653,0-26.576,11.922-26.576,26.576 0.001,14.653 11.923,26.576 26.576,26.576zm0-36.333c5.38,0 9.758,4.377 9.758,9.757s-4.378,9.757-9.758,9.757c-5.38,0-9.757-4.377-9.757-9.757s4.377-9.757 9.757-9.757z"></path> <path d="m115.635,19.452c-3.285-3.283-8.608-3.283-11.893,0-3.284,3.285-3.284,8.609 0,11.893l15.023,15.022c-58.18,2.807-104.684,49.598-105.203,112.411l-10.29,17.823c-1.115,1.931-1.417,4.227-0.84,6.381 0.577,2.154 1.986,3.991 3.918,5.106l9.058,5.23-9.058,5.23c-1.931,1.115-3.341,2.952-3.918,5.106-0.578,2.154-0.275,4.45 0.84,6.381l19.737,34.185c2.322,4.023 7.464,5.398 11.487,3.078l9.058-5.23v10.459c0,4.644 3.765,8.409 8.409,8.409h39.473c4.644,0 8.409-3.765 8.409-8.409v-10.459l9.058,5.23c1.931,1.115 4.227,1.417 6.381,0.84 2.154-0.577 3.991-1.986 5.106-3.918l19.736-34.185c2.322-4.022 0.944-9.165-3.078-11.487l-9.059-5.23 9.059-5.23c4.022-2.323 5.4-7.465 3.078-11.487l-19.736-34.185c-1.115-1.931-2.952-3.341-5.106-3.918-2.154-0.58-4.45-0.275-6.381,0.84l-9.058,5.23v-10.46c0-4.644-3.765-8.409-8.409-8.409h-39.472c-4.644,0-8.409,3.765-8.409,8.409v10.46l-9.058-5.23c-0.732-0.422-1.501-0.719-2.284-0.902 8.265-41.08 43.409-72.543 86.229-75.196l-14.7,14.699c-3.284,3.284-3.284,8.609 0,11.893 1.642,1.641 3.794,2.463 5.947,2.463s4.304-0.821 5.947-2.463l29.244-29.244c1.577-1.578 2.463-3.717 2.463-5.947 0-2.231-0.886-4.369-2.463-5.947l-29.245-29.242zm-67.876,146.964c2.603,1.501 5.806,1.501 8.409,0 2.602-1.502 4.205-4.278 4.205-7.283v-16.617h22.655v16.617c0,3.005 1.603,5.78 4.205,7.283 2.603,1.501 5.808,1.501 8.409,0l14.39-8.308 11.327,19.619-14.39,8.308c-2.602,1.502-4.205,4.278-4.205,7.283s1.603,5.78 4.205,7.283l14.39,8.308-11.327,19.619-14.39-8.308c-2.603-1.501-5.808-1.501-8.409,0-2.602,1.502-4.205,4.278-4.205,7.283v16.616h-22.655v-16.616c0-3.005-1.603-5.78-4.205-7.283-2.603-1.501-5.806-1.501-8.409,0l-14.39,8.308-11.328-19.619 14.39-8.308c2.602-1.502 4.205-4.278 4.205-7.283s-1.603-5.78-4.205-7.283l-14.39-8.308 11.328-19.619 14.39,8.308z"></path> </g> </g></svg>',
}

export enum DxDrawerRevealMode {
  slide = 'slide',
  expand = 'expand',
}

export enum DxDrawerOpenedStateMode {
  overlap = 'overlap',
  shrink = 'shrink',
  push = 'push',
}

@Component({
  selector: 'digitalization-tool-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss'],
  standalone: false,
})
export class CoreComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(_AbcScrollViewComponent, { static: true }) scrollView: _AbcScrollViewComponent;
  @ViewChild('treeview') menu: _AbcTreeComponent;
  @ViewChild('toast', { static: false }) dxToast: AbcToastComponent;
  @ViewChild('favorites') favorites: FavoriteListComponent;
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      .filter((cl) => this.screen.sizes[cl])
      .join(' ');
  }
  @Output() openMenu = new EventEmitter<MouseEvent>();
  public isFavoriteOpen = false;
  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;
    if (!this.menu.instance) {
      return;
    }
    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }
  @Input() set selectedItem(value: string) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }
    this.menu.instance.selectItem(value);
  }
  title = 'digitalization-tool';
  public iunitlogo = `<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536.78 335.52"><defs><style>.cls-1{fill:#fff;}</style></defs><title>iunitgroup-gruppenlogo_w</title><path class="cls-1" d="M197.23,278.6c1.29.95,3.9,1.45,5.93,1.45a15.85,15.85,0,0,0,12.3-5.49c3.76-4.35,5.64-11.15,5.64-18.31,0-9.41-4.77-12.67-9.91-12.67-5.57,0-8.61,3-10.79,6.15h-.71l.71-5.42a8.86,8.86,0,0,0-2.46-.29,13.67,13.67,0,0,0-6.65,1.66,8.15,8.15,0,0,0-1.3,3.69l5.13-.58L189.33,295a9.67,9.67,0,0,0,2.68.29,22.46,22.46,0,0,0,3.47-.29ZM200,254.36c1.53-2.89,5-5.86,8.25-5.86,4.42,0,6.51,3.4,6.51,9.48,0,5.43-.86,10.93-3.61,14.19a10.13,10.13,0,0,1-8.25,3.54,14.9,14.9,0,0,1-5.36-1Zm-26.8,20.12a15.92,15.92,0,0,0,1.81,5.57,32.71,32.71,0,0,0,8.54-1.66,9.9,9.9,0,0,0,1.16-4.05l-5.44.5a5.87,5.87,0,0,1-.35-1.37l3.33-29.16a17.7,17.7,0,0,0-2.9-.29,14.67,14.67,0,0,0-6.88,1.59,8.42,8.42,0,0,0-1.3,3.76l5-.58-2.74,20.91a10.41,10.41,0,0,1-8.69,5.43c-3.69,0-5.06-2.38-5.06-6.15,0-2.89,1.66-17,2.67-24.67a17.73,17.73,0,0,0-3-.29,16,16,0,0,0-7.16,1.66,7.89,7.89,0,0,0-1.31,3.69l5.28-.58c-.72,4.05-2.89,17.66-2.89,22.43,0,6.88,4.19,8.83,8.32,8.83,5.43,0,9-2.24,11.22-5.57Zm-43.64,1.31c-4.19,0-6.36-4-6.36-10.28,0-4.34.5-8.61,2.17-11.94s4.55-5.79,8.18-5.79c4.12,0,6.29,4.12,6.29,10,0,4.7-.87,9.62-2.82,13-1.74,3-4.27,5-7.46,5m-.72,4.26a15.38,15.38,0,0,0,12.74-6.58c2.89-4.13,4.49-10,4.49-16.35,0-8.69-4.57-13.54-11.94-13.54-5.72,0-10.57,3.11-13.61,8a28,28,0,0,0-3.62,14.62c0,9.12,4.2,13.89,11.94,13.89m-27.57-28.44.94-7.3a8.86,8.86,0,0,0-2.46-.29,13.71,13.71,0,0,0-6.66,1.66,8.15,8.15,0,0,0-1.3,3.69l5.36-.58-3.91,29.89a9.3,9.3,0,0,0,2.68.29,23.77,23.77,0,0,0,3.47-.29l2.24-22.21c1.74-4.71,5-7.1,8.54-7.1a8.69,8.69,0,0,1,4.92,1.45,12.5,12.5,0,0,0,.51-3.33,10,10,0,0,0-.51-3.26,8.77,8.77,0,0,0-3.47-.65c-5,0-8.25,3.91-9.63,8ZM77.39,269.27c-1.88,3.4-5,5.5-8,5.5-3.84,0-6.3-2.67-6.3-8.68,0-4,.87-9.77,3.11-13.31,1.89-2.9,4.92-5.36,8.83-5.36a10.47,10.47,0,0,1,4.85,1.15Zm8.47-22.43a18.36,18.36,0,0,0-10.64-3.26,16.52,16.52,0,0,0-13.53,7.09c-3.11,4.27-4.78,10.21-4.78,16.21,0,9.12,4.06,12.81,9.55,12.81a12.88,12.88,0,0,0,10.64-5.86h.73a44.29,44.29,0,0,0-1.38,6.22c-1,6.66-3.69,11.44-10.21,11.44a22.32,22.32,0,0,1-11.14-3.55,9.1,9.1,0,0,0-.21,1.95,10.82,10.82,0,0,0,.86,4.42,29.84,29.84,0,0,0,10.36,1.95c11.79,0,15.48-9.05,16.64-20Z"/><path class="cls-1" d="M204.89,192.83a17.45,17.45,0,0,0-4.12,1.23,10,10,0,0,0-1.38,3.76h5.22c-1.23,7.23-3.12,19.83-3.12,23.88,0,4.48,1.95,7.16,6.66,7.16a18.3,18.3,0,0,0,8.4-2.31,9.31,9.31,0,0,0,.93-3.84,17.81,17.81,0,0,1-6.15,1.38c-3,0-3.83-1.88-3.47-5.72l2-20.55H220.3a17.72,17.72,0,0,0,.3-2.9,8.11,8.11,0,0,0-.08-1.3h-10l1.08-10.35a10.11,10.11,0,0,0-4.63,1.16Zm-16.13-16.36a3.89,3.89,0,0,0-4,3.78v.22c0,2.82,1.38,4.27,4,4.27,2.24,0,3.91-1.59,3.91-4.27a3.66,3.66,0,0,0-3.32-4,3.85,3.85,0,0,0-.59,0m-4.71,21.13-3.76,25.91c0,1.23,1.16,3.76,2.53,5.35a32,32,0,0,0,8.62-1.66,10.3,10.3,0,0,0,1.15-4.06l-5.64.58a4.37,4.37,0,0,1-.37-1.23l3.63-29.38a20,20,0,0,0-3-.28,16,16,0,0,0-7.16,1.66,8.15,8.15,0,0,0-1.3,3.69ZM149.17,199l.65-5.87a8.85,8.85,0,0,0-2.46-.28,13.67,13.67,0,0,0-6.65,1.66,8.15,8.15,0,0,0-1.3,3.69l5.27-.58-4,29.89a9.3,9.3,0,0,0,2.68.29,23.77,23.77,0,0,0,3.47-.29l2.68-23.81c1.37-2.89,4.84-6.51,8.83-6.51,3.47,0,4.92,2.46,4.92,6.22s-1.89,14.83-2.83,20.12c0,1.23,1.16,3.76,2.53,5.35a29.67,29.67,0,0,0,8.55-1.66,10,10,0,0,0,1.15-4.06l-5.57.58a3.79,3.79,0,0,1-.36-1.23c.43-3.32,2.68-16.78,2.68-21.13,0-7.23-4.06-9-8.4-9A12,12,0,0,0,149.9,199Zm-27.64,24.31a15.92,15.92,0,0,0,1.81,5.57,32.71,32.71,0,0,0,8.54-1.66,10,10,0,0,0,1.16-4.06l-5.43.51a5.43,5.43,0,0,1-.36-1.37l3.33-29.17a18.86,18.86,0,0,0-2.9-.28,14.63,14.63,0,0,0-6.87,1.59,8.42,8.42,0,0,0-1.3,3.76l5-.58-2.75,20.92a10.43,10.43,0,0,1-8.69,5.42c-3.69,0-5.06-2.38-5.06-6.15,0-2.9,1.67-17,2.68-24.68a20,20,0,0,0-3-.28,16,16,0,0,0-7.16,1.66,7.89,7.89,0,0,0-1.31,3.69l5.29-.58c-.73,4.06-2.9,17.66-2.9,22.43,0,6.88,4.2,8.83,8.32,8.83,5.43,0,9-2.24,11.22-5.57ZM92.3,210.7a21.39,21.39,0,0,0,.36-3.91,9.92,9.92,0,0,0-.07-1.44H76.88a19.16,19.16,0,0,0-1,5.35ZM66.68,176.47a3.88,3.88,0,0,0-4,3.76v.24c0,2.82,1.38,4.27,4,4.27,2.25,0,3.91-1.59,3.91-4.27a3.66,3.66,0,0,0-3.32-4,3.85,3.85,0,0,0-.59,0M62,197.6l-3.77,25.91c0,1.23,1.16,3.76,2.54,5.35a32,32,0,0,0,8.61-1.66,10,10,0,0,0,1.15-4.06l-5.64.58a4.45,4.45,0,0,1-.36-1.23l3.62-29.38a20,20,0,0,0-3-.28A16,16,0,0,0,58,194.49a7.89,7.89,0,0,0-1.31,3.69Z"/><rect class="cls-1" x="243.18" y="192.7" width="36.01" height="86.12"/><rect class="cls-1" x="293.4" y="166.29" width="36.01" height="112.54"/><rect class="cls-1" x="393.85" y="184.65" width="36.02" height="94.18"/><rect class="cls-1" x="444.08" y="56.69" width="36.01" height="222.12"/><rect class="cls-1" x="343.63" y="78.99" width="36.02" height="199.83"/></svg>`;
  private subscriptions: Subscription[] = [];
  public selectedRoute = '';
  public menuOpened: boolean;
  public menuMode: DxDrawerOpenedStateMode = DxDrawerOpenedStateMode.shrink;
  public menuRevealMode: DxDrawerRevealMode = DxDrawerRevealMode.expand;
  public minMenuSize = 0;
  public shaderEnabled = false;
  public tooltipContent: string;
  public target: EventTarget;
  public isDefaultLanguageDe = true;
  public isVisible = false;
  private _selectedItem: string;
  private _temporaryMenuOpened = false;
  public companyName = '';
  public currentUser: LoginInfo;
  public titleApplication: string;
  public dtLogo = '<img src="assets/images/custom/logoMenu.svg" alt="Logo" />';
  public contextMenuItems = [
    {
      text: 'Logout',
      icon: 'assets/images/custom/logout.svg',
      onClick: () => {
        this.logout();
      },
    },
  ];
  @ViewChild('toast', { static: false }) toast: AbcToastComponent;
  public toastTemplate = 'success';
  public toastMessage: string;
  public toastPosition: PositionIValue = {
    at: Position.TOP,
    my: Position.CENTER,
    offset: '0 60',
  };
  public toastAnimation: IToastAnimation = {
    show: {
      type: ToastAnimationShowType.SLIDE,
      duration: 200,
      from: { position: { my: Position.TOP, at: Position.BOTTOM } },
    },
  };

  @Input() contextmenuMode: string;
  public languageIsChanged = false;
  public navigation: NavigationMenu[] = [];

  constructor(
    private screen: ScreenService,
    private elementRef: ElementRef,
    private userService: UserService,
    private coreDataService: CoreDataService,
    public dataService: DataService,
    private router: Router,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private resourceManagerService: ResourceManagerService,
    private languageService: LanguageService
  ) {
    loadMessages(dtDe);
    loadMessages(dtEn);
    loadMessages(deMessages);
    loadMessages(enMessages);

    this.navigation = [
      {
        text: this.dataService.res('Dt-TreeList-Home'),
        component: 'Dt-TreeList-Home',
        path: '/home',
        icon: NavigationSvg.HOME,
      },
      {
        text: this.dataService.res('Dt-TreeList-Customer-History'),
        component: 'Dt-TreeList-Customer-History',
        path: '/customer-history',
        icon: NavigationSvg.COMPANY,
      },
      {
        text: this.dataService.res('Dt-TreeList-Dashboard'),
        component: 'Dt-TreeList-Dashboard',
        path: '/dashboard',
        icon: NavigationSvg.DASHBOARD,
      },
      {
        text: this.dataService.res('Dt-TreeList-Audit'),
        component: 'Dt-TreeList-Audit',
        path: '/audits',

        icon: NavigationSvg.AUDIT,
      },
      {
        text: this.dataService.res('Dt-TreeList-Libraries'),
        component: 'Dt-TreeList-Libraries',
        icon: NavigationSvg.LIBRARY,
        isExpanded: false,
        items: [
          {
            text: this.dataService.res('Dt-TreeList-Library'),
            component: 'Dt-TreeList-Library',
            path: '/libraries',
            icon: NavigationSvg.LIBRARY,
          },
          {
            text: this.dataService.res('Dt-TreeList-Category'),
            component: 'Dt-TreeList-Category',
            path: '/categories',
            icon: NavigationSvg.MODULE,
          },
          {
            text: this.dataService.res('Dt-TreeList-Question'),
            component: 'Dt-TreeList-Question',
            path: '/questions',
            icon: NavigationSvg.TASK,
          },
          {
            text: this.dataService.res('Dt-TreeList-Answer'),
            component: 'Dt-TreeList-Answer',
            path: '/responses',
            icon: NavigationSvg.REPORTS,
          },
          {
            text: this.dataService.res('Dt-TreeList-Measure'),
            component: 'Dt-TreeList-Measure',
            path: '/recommendations',
            icon: NavigationSvg.MEASURES,
          },
        ],
      },
      // {
      //   text: this.dataService.res('Dt-TreeList-Administration'),
      //   component: 'Dt-TreeList-Administration',
      //   icon: NavigationSvg.ADMINISTRATION,
      //   isExpanded: false,
      //   items: [
      //     {
      //       text: this.dataService.res('Dt-TreeList-Staff-Members'),
      //       component: 'Dt-TreeList-Staff-Members',
      //       path: '/staff-members',
      //       icon: NavigationSvg.STAFF_MEMBERS,
      //     }
      //   ],
      // },
      {
        text: this.dataService.res('Dt-TreeList-Favorite'),
        component: 'Dt-TreeList-Favorite',
        icon: NavigationSvg.FAVORITE,
      },
    ];

    this.languageService.localStorageChanges$.subscribe((language) => {
      document.documentElement.lang = language;
    });

    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.router.navigated = false;
        }
      })
    );
  }

  public ngOnInit() {
    this.titleApplication =
      this.appService.getCustomSpecificInfo().NeedsTranslation[
        sessionStorage.getItem('currentUserLanguage') ?? 'de'
      ].TitleApplication;
    this.companyName = localStorage.getItem(StorageEnum.CompanyName);
    this.subscriptions.push(
      this.dataService.companyName$.subscribe((name: string) => {
        this.companyName = name;
      })
    );

    this.subscriptions.push(
      this.userService.getCurrentLoginInfo().subscribe(
        (user) => {
          if (user) {
            this.currentUser = user;
            this.prepareProfileAndCompany().subscribe((data) => {
              if (data) {
                const profileId: string = data[0][0]?.Id;
                localStorage.setItem('profileId', profileId);
                sessionStorage.setItem('profileId', profileId);
                this.dataService.cachedStatus = data[1].Data;
                this.dataService.cachedCompaniesTitles = data[2].Data;
                this.dataService.setColumnsReady(true);
              }
            });
          }
        },
        (error) => {
          console.error(error);
        }
      )
    );

    if (
      (!this.currentUser?.displayName || !localStorage.getItem('profileId')) &&
      localStorage.getItem('refresh_token')
    ) {
      this.subscriptions.push(
        forkJoin([this.userService.getCurrentLoginInfo(), this.prepareProfileAndCompany()]).subscribe(
          (data) => {
            const profileId: string = data[1][0][0].Id;
            //this.currentUser.displayName = data[0].displayName;
            localStorage.setItem('profileId', profileId);
            sessionStorage.setItem('profileId', profileId);
            this.dataService.cachedStatus = data[1][1].Data;
            this.dataService.cachedCompaniesTitles = data[1][2].Data;
            this.dataService.setColumnsReady(true);
          },
          (error) => {
            console.error(error);
          }
        )
      );
    }
    this.menuOpened = this.screen.sizes['screen-large'];
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });
    this.updateDrawer();
    this.subscriptions.push(
      this.appService.notification$.subscribe((notification) => {
        this.toast.displayTime = notification.type === ToastType.ERROR ? 5000 : 3000;
        this.toast.visible = true;
        this.toast.width = 'auto';
        this.toastMessage = notification.message;
        this.toastTemplate =
          notification.type === ToastType.SUCCESS ? 'success' : notification.type === ToastType.INFO ? 'info' : 'error';
        this.toast.position = {
          at: 'top',
          my: 'center',
          offset: '0 60',
        };
        this.toast.animation = {
          show: {
            type: ToastAnimationShowType.SLIDE,
            duration: 200,
            from: { position: { my: Position.TOP, at: Position.BOTTOM } },
          },
        };
      })
    );
  }
  public onMenuItemClick(event) {
    if (event.itemData.text === this.dataService.res('Dt-TreeList-Favorite')) {
      event.itemElement?.classList.add('favorite');
      this.menu?.instance.unselectAll();
      this.isFavoriteOpen = true;

      if (this.isFavoriteOpen) {
        setTimeout(() => {
          this.favorites.openFavorites();
        }, 100);
      } else {
        setTimeout(() => {
          this.favorites?.closeFavorites();
          document.getElementById('container').style.opacity = '1';
        });
      }
    } else {
      const favoriteElement = document.getElementsByClassName('favorite');
      favoriteElement[0]?.classList.remove('favorite');

      this.removeFavoriteItem(event.itemData.text);
      document.getElementById('container').style.opacity = '1';
      this.isFavoriteOpen = false;
    }

    if (this.showMenuAfterClick) {
      this._temporaryMenuOpened = true;
      this.menuOpened = true;
    }
    const path = event.itemData.path;
    const pointerEvent = event.event;
    if (path && this.menuOpened) {
      this.router.navigate([path]);
      this.scrollView?.instance.scrollTo(0);
      if (this.hideMenuAfterNavigation) {
        this._temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
    this.menu.instance.selectItem(event.itemData.path);
  }
  private prepareProfileAndCompany() {
    const frofileColumns = [this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None)];
    const profileOPath = 'Login=' + "'" + sessionStorage.getItem('userName') + "'";
    return forkJoin([
      this.dataService.readObjects(ObjectKeys.Person, frofileColumns, profileOPath),
      this.dataService.loadListDataSource(ObjectKeys.ADDRESS, 'Status'),
      this.dataService.loadListDataSource(ObjectKeys.ADDRESS, 'CompanyTitle'),
    ]);
  }
  public logout(): void {
    this.menu?.instance.unselectAll();
    this.menu?.instance.selectItem('/customer-history');
    this.dataService.companyName.next('');
    this.userService.logoutCurrentUser();
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigateByUrl('/login', { skipLocationChange: true }).then(() => {
      this.dataService.companyData = null;
    });
  }
  public testChildElement(items, index): any {
    for (let i = index; i > -1; i--) {
      if (items[i]?.items?.length > 0) {
        return [i, index - (i + 1)];
      }
    }
    return 0;
  }
  public sideNavTranslation() {
    this.navigation = [
      ...this.navigation.map((item) => {
        if (
          (item.component === 'Dt-TreeList-Libraries' || item.component === 'Dt-TreeList-Administration') &&
          item.items
        ) {
          return {
            ...item,
            text: this.dataService.res(item.component),
            items: item.items.map((subItem) => ({
              ...subItem,
              text: this.dataService.res(subItem.component),
            })),
          };
        } else {
          return {
            ...item,
            text: this.dataService.res(item.component),
          };
        }
      }),
    ];
  }
  public changeLanguage = (l: boolean) => {
    this.isDefaultLanguageDe = l;
    this.languageService.setValue('fixedCulture', l ? 'de' : 'en');
    this.router.navigate([this.router.url]);
    this.titleApplication =
      this.appService.getCustomSpecificInfo().NeedsTranslation[
        sessionStorage.getItem('currentUserLanguage') ?? 'de'
      ].TitleApplication;

    this.cdr.detectChanges();
    this.sideNavTranslation();
  };

  public ngAfterViewInit() {
    this.resourceManagerService.changeLanguage(sessionStorage.getItem('fixedCulture'));

    events.on(this.elementRef.nativeElement, 'dxclick', (event: MouseEvent) => {
      this.openMenu.next(event);
    });
  }
  public onContentReady(e): void {
    const elements = e.component.element().querySelectorAll('.dx-treeview-item');
    elements.forEach((el, index) => {
      el.addEventListener('mouseenter', (event) => {
        const icone = el.querySelector('.dx-icon');
        if (!this.menuOpened) {
          if (e.component._dataAdapter.options.items[index]?.text) {
            this.tooltipContent = e.component._dataAdapter.options.items[index].text;
            this.target = icone;
            this.isVisible = true;
          } else if (this.testChildElement(e.component._dataAdapter.options.items, index)) {
            const [parentIndex, childIndex] = this.testChildElement(e.component._dataAdapter.options.items, index);
            const subElement = e.component._dataAdapter.options.items[parentIndex]?.items[childIndex];
            if (subElement.text.length > 0) {
              this.tooltipContent = subElement.text;
              this.target = icone;
              this.isVisible = true;
            }
          }
        }
      });
      el.addEventListener('mouseleave', (event) => {
        this.isVisible = false;
      });
    });
  }

  private updateDrawer() {
    const isSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];
    this.menuMode = isLarge ? DxDrawerOpenedStateMode.shrink : DxDrawerOpenedStateMode.overlap;
    this.menuRevealMode = isSmall ? DxDrawerRevealMode.slide : DxDrawerRevealMode.expand;
    this.minMenuSize = isSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  public toggleMenu = (e) => {
    this.menuOpened = !this.menuOpened;
    e.stopPropagation();
  };

  public isAuthenticated(): boolean {
    if (this.userService.isCurrentlyLoggedInOrAnonymousAllowed && this.selectedRoute !== '/login') {
      return true;
    }
  }

  @HostListener('document:click', ['$event.target']) onMouseClick(targetElement) {
    const favouritesContainerClicked = document.getElementById('container')?.contains(targetElement);
    const favouritesButtonClicked = document.getElementById('favouritesContainer')?.contains(targetElement);
    if (!favouritesButtonClicked && favouritesContainerClicked) {
      this.favorites?.closeFavorites();
    }
  }

  public removeFavoriteItem(favoriteItem: string): void {
    switch (favoriteItem) {
      //   //TODO verify with favorite
      // case this.dataService.res('Dt-TreeList-Audit'): {
      //    this.dataService.companyName.next(undefined);
      //  localStorage.setItem('companyName', '');
      //   break;
      // }
      case this.dataService.res('Dt-TreeList-Library'): {
        this.dataService.setFavoriteData('library', '');
        localStorage.setItem('libraryName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Category'): {
        this.dataService.setFavoriteData('category', '');
        localStorage.setItem('categoryName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Question'): {
        this.dataService.setFavoriteData('question', '');
        localStorage.setItem('questionName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Answer'): {
        this.dataService.setFavoriteData('answer', '');
        localStorage.setItem('responseName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Measure'): {
        this.dataService.setFavoriteData('measure', '');
        localStorage.setItem('measureName', '');
        break;
      }
      default: {
        break;
      }
    }
  }

  public closeFavorites() {
    this.isFavoriteOpen = false;
  }
  public onRouterOutletActivate() {
    this.menu?.instance.selectItem(this.router.url);
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this._temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  public headerMainTitleCSS = (): string => {
    return 'header-main-title';
  };

  public ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
interface LoginInfo {
  isAnonymous: boolean;
  userName: string;
  issued: Date;
  expires: Date;
  userId?: string;
  displayName?: string;
  isAdmin?: boolean;
  hasAvatar?: boolean;
}
